export const normalizeRequestId = (value: unknown): number | undefined => {
    const id = Number(value);
    return Number.isSafeInteger(id) && id > 0 ? id : undefined;
};

export interface RequestSelection {
    clientId?: number;
    branchId?: number;
}

const selectionKey = 'newRequestSelection';

export const readRequestSelection = (): RequestSelection => {
    try {
        const stored = localStorage.getItem(selectionKey);
        const selection = stored ? JSON.parse(stored) : {
            clientId: JSON.parse(localStorage.getItem('selectedClient') || 'null')?.id,
            branchId: JSON.parse(localStorage.getItem('selectedBranch') || 'null')?.id,
        };
        const clientId = normalizeRequestId(selection?.clientId);
        return { clientId, branchId: clientId ? normalizeRequestId(selection?.branchId) : undefined };
    } catch {
        return {};
    }
};

export const persistRequestSelection = (selection: RequestSelection) => {
    localStorage.setItem(selectionKey, JSON.stringify(selection));
    if (!selection.clientId) localStorage.removeItem('selectedClient');
    if (!selection.branchId) {
        localStorage.removeItem('selectedBranch');
        localStorage.removeItem('markerID');
        localStorage.removeItem('paymentInfo');
    }
};
